module.exports = __webpack_public_path__ + "img/taco.b438fe86.png";